import { DocumentUpload } from "$src/domain/projects/documents/DocumentUpload";
import { writable } from "svelte/store";
  
export const documentUploads = writable<DocumentUpload[]>([]);
export const documentRefresh = writable(0);